function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJeur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 399.99999 344.05591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M372.93382,113.43872C319.2791,32.26465,203.69707-16.28137,114.77427,5.00812,75.856,14.32575,48.49492,35.47638,34.52696,63.12226L14.33677,96.62403c-.22424,.36932-.44983,.73798-.66895,1.10999l-.2489,.41302,.00226,.01813C-7.6053,134.28565-4.56087,182.77686,27.06077,230.61719c53.65472,81.17407,169.23676,129.72009,258.15955,108.4306,35.01849-8.38397,60.67212-26.35236,75.6391-50.00848l.01758-.0127,.242-.40698c.77997-1.2467,1.53082-2.50873,2.25146-3.78625l21.04926-35.39856-.00067-.00031c23.36017-36.45441,21.18127-86.57477-11.48523-135.99579Z",
    style: {
      fill: "#002259"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 207.32099,
    cy: 159.65347,
    rx: 138.14913,
    ry: 198.40776,
    transform: "translate(-27.82241 274.45245) rotate(-63.62112)",
    style: {
      fill: "#bacde8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.6454,
    cy: 154.22582,
    rx: 136.6562,
    ry: 196.31155,
    transform: "translate(-20.88241 274.85733) rotate(-63.73063)",
    style: {
      fill: "#039"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "139.25644 40.10596 149.67492 49.65272 160.98648 47.12182 156.62058 56.01722 166.30041 64.40948 152.55237 60.88673 146.19097 68.90885 144.05219 58.82932 130.82233 53.87088 142.13389 51.33998 139.25644 40.10596",
    style: {
      fill: "#fc0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.81945 66.33308 103.23794 75.87983 114.54949 73.34894 108.18809 81.37105 118.60658 90.91781 106.11538 87.11385 99.75399 95.13597 96.87653 83.90195 83.12851 80.3792 95.6969 77.5671 92.81945 66.33308",
    style: {
      fill: "#fc0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.98096 112.55662 85.39944 122.10337 97.96784 119.29126 91.60644 127.3134 102.02493 136.86015 87.53823 132.18291 83.17234 141.07831 80.29488 129.84429 66.54685 126.32153 77.8584 123.79064 74.98096 112.55662",
    style: {
      fill: "#fc0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.42134 41.58653 213.83983 51.13329 226.40821 48.32119 220.04681 56.3433 230.4653 65.89006 216.71728 62.36731 211.61271 70.10822 208.73525 58.8742 194.98724 55.35145 206.29878 52.82056 203.42134 41.58653",
    style: {
      fill: "#fc0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.2688 75.39275 281.90739 83.41488 292.32586 92.96163 278.57784 89.43888 273.47329 97.17979 270.59584 85.94578 256.84782 82.42302 268.15936 79.89212 265.28191 68.65811 275.70039 78.20486 288.2688 75.39275",
    style: {
      fill: "#fc0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.85204 122.81567 329.49064 130.83779 339.90912 140.38454 326.67927 135.42609 321.05652 144.60271 318.17907 133.36869 304.43105 129.84594 316.99943 127.03383 314.12201 115.79981 323.28365 125.62778 335.85204 122.81567",
    style: {
      fill: "#fc0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.10771 191.96632 342.62103 187.28909 336.9983 196.46569 334.12085 185.23168 321.62966 181.42771 332.94121 178.89682 330.06376 167.6628 340.48224 177.20956 353.05065 174.39745 346.68924 182.41958 357.10771 191.96632",
    style: {
      fill: "#fc0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.23648 268.35394 272.35905 257.11993 257.87234 252.44267 270.44074 249.63057 267.5633 238.39656 277.98177 247.9433 289.29333 245.41241 284.92744 254.30783 294.08909 264.13578 280.85923 259.17734 275.23648 268.35394",
    style: {
      fill: "#fc0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.07159 266.87335 208.19414 255.63934 194.44612 252.1166 205.75767 249.5857 202.88023 238.35169 213.29871 247.89844 225.86711 245.08633 219.5057 253.10845 229.92418 262.65519 216.17614 259.13245 211.07159 266.87335",
    style: {
      fill: "#fc0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.26922 238.18986 326.03938 233.23142 320.41663 242.40802 317.53919 231.17401 303.79115 227.65127 316.35955 224.83916 313.48212 213.60515 323.9006 223.15189 335.21214 220.621 328.85075 228.64312 339.26922 238.18986",
    style: {
      fill: "#fc0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.48412 179.05781 97.05252 176.2457 92.91823 165.29289 103.33671 174.83965 115.90511 172.02754 109.54371 180.04966 119.96219 189.59642 106.21417 186.07367 101.1096 193.81458 98.23215 182.58055 84.48412 179.05781",
    style: {
      fill: "#fc0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.95868 239.20972 143.08123 227.97571 129.3332 224.45295 141.90159 221.64084 139.02414 210.40682 149.44263 219.95358 160.75419 217.42268 155.64963 225.1636 166.0681 234.71035 151.58142 230.03311 145.95868 239.20972",
    style: {
      fill: "#fc0"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJeur);
export default __webpack_public_path__ + "static/media/jeur.c3ad5274f3552336d6529e8e31e4e89c.svg";
export { ForwardRef as ReactComponent };